"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _argumentContracts = _interopRequireDefault(require("argument-contracts"));

var _axisLabelFormatters = require("../../label-formatters/axis-label-formatters");

var _getValidObject = _interopRequireDefault(require("../../get-valid-object"));

var _isHexColorValue = _interopRequireDefault(require("../../is-hex-color-value"));

var _styles = require("../../styles");

var DEFAULT_DATA_LABEL_FORMATTER = function DEFAULT_DATA_LABEL_FORMATTER() {
  return '';
};

var DEFAULT_ON_POINT_CLICK = function DEFAULT_ON_POINT_CLICK() {};

var DEFAULT_SELECTED_POINTS = [];
var DEFAULT_Y_AXIS_LABEL_FORMATTER = _axisLabelFormatters.AxisLabelFormatters.DEFAULT_NUMBER_LABEL;
/**
 * @callback MwChartOneSeriesColumnClick
 *
 * Custom behavior to handle a click on a column.
 *
 * @param {MwChartOneSeriesColumnClickOptions} options Options provided by the chart
 * @returns {function} Function callback.
 */

/**
 * @callback MwChartOneSeriesColumnLabelFormatter
 *
 * Custom behavior to format the data label for a particular value.
 *
 * @param {MwChartOneSeriesColumnLabelFormatterOptions} options Options provided by the chart
 * @returns {string} Text to show as the data label
 */

/**
 * @callback MwChartOneSeriesColumnTooltipFormatter
 *
 * Custom behavior to transform point information into an HTML tooltip.
 *
 * @param {MwChartOneSeriesColumnTooltipOptions} options Options provided by the chart
 * @returns {string} HTML to show in the tooltip
 */

/**
 * @callback MwChartOneSeriesColumnYAxisLabelFormatter
 *
 * Custom behavior to format the label for the y-axis.
 *
 * @param {AxisLabelFormatterOptions} options Options provided by the chart
 * @returns {string} Text to show as the y-axis label
 */

/**
 * A class to represent the visualization options for a Column Chart
 * @param {object} options options object (See below)
 * @param {MwChartOneSeriesColumnLabelFormatter} [options.dataLabelFormatter] - A function to be passed a value to format data label. If not provided no label will be displayed.
 * @param {number[]} [options.selectedIndexPoints] - An array of pre selected points by their series index
 * @param {MwChartOneSeriesColumnClick} [options.onPointClick] - A function to be passed a point data object (ie seriesIndex, seriesName, value) on click
 * @param {string} [options.seriesColor] - A hex color value for the one series color (Eg #ffbbcc). If not provided default color will be displayed.
 * @param {MwChartOneSeriesColumnTooltipFormatter} [options.tooltipFormatter] - Custom handler to format tooltips
 * @param {MwChartOneSeriesColumnYAxisLabelFormatter|AxisLabelFormatters} [options.yAxisLabelFormatter=AxisLabelFormatters.DEFAULT_NUMBER_LABEL] - A function to format y-axis labels, or a named AxisLabelFormatter. If provided a function, the function is provided AxisLabelFormatterOptions.
 * @param {string} [options.yAxisTitle] The Y Axis title text
 */

var MwChartOneSeriesColumnOptions = function MwChartOneSeriesColumnOptions(options) {
  (0, _classCallCheck2.default)(this, MwChartOneSeriesColumnOptions);
  var safeOptions = (0, _getValidObject.default)(options);

  if (safeOptions.dataLabelFormatter === undefined) {
    safeOptions.dataLabelFormatter = DEFAULT_DATA_LABEL_FORMATTER;
  } else if (typeof safeOptions.dataLabelFormatter !== 'function') {
    throw new TypeError("options.dataLabelFormatter must be a function. Provided value: ".concat(JSON.stringify(safeOptions.dataLabelFormatter)));
  }

  if (safeOptions.onPointClick === undefined) {
    safeOptions.onPointClick = DEFAULT_ON_POINT_CLICK;
  } else if (typeof safeOptions.onPointClick !== 'function') {
    throw new TypeError("options.onPointClick must be a function. Provided value: ".concat(safeOptions.onPointClick));
  }

  if (!safeOptions.seriesColor) {
    safeOptions.seriesColor = _styles.DEFAULT_SERIES_CHART_COLORS[0];
  } else if (!(0, _isHexColorValue.default)(safeOptions.seriesColor)) {
    throw new TypeError("options.seriesColor must be a valid hex color value. Provided value: ".concat(safeOptions.seriesColor));
  }

  if (safeOptions.selectedIndexPoints === undefined) {
    safeOptions.selectedIndexPoints = DEFAULT_SELECTED_POINTS;
  } else if (!Array.isArray(safeOptions.selectedIndexPoints) || !safeOptions.selectedIndexPoints.every(function (index) {
    return typeof index === 'number';
  })) {
    throw new TypeError("selectedIndexPoints must be an valid number array. Provided value: ".concat(JSON.stringify(safeOptions.selectedIndexPoints)));
  }

  if (typeof safeOptions.tooltipFormatter !== 'function' && safeOptions.tooltipFormatter !== undefined) {
    throw new TypeError("options.tooltipFormatter must be a function. Provided value: ".concat(JSON.stringify(safeOptions.tooltipFormatter)));
  }

  if (safeOptions.yAxisLabelFormatter === undefined) {
    safeOptions.yAxisLabelFormatter = DEFAULT_Y_AXIS_LABEL_FORMATTER;
  } else if (typeof safeOptions.yAxisLabelFormatter === 'string') {
    if (!(0, _axisLabelFormatters.isValidAxisLabelFormatter)(safeOptions.yAxisLabelFormatter)) {
      throw new TypeError("options.yAxisLabelFormatter must be a known AxisLabelFormatter if provided as a string. Provided value: ".concat(safeOptions.yAxisLabelFormatter));
    }
  } else {
    _argumentContracts.default.assertFunction(safeOptions.yAxisLabelFormatter, 'options.yAxisLabelFormatter');
  }

  if (safeOptions.yAxisTitle !== undefined) {
    _argumentContracts.default.assertString(safeOptions.yAxisTitle, 'options.yAxisTitle');
  }

  this.dataLabelFormatter = safeOptions.dataLabelFormatter;
  this.onPointClick = safeOptions.onPointClick;
  this.seriesColor = safeOptions.seriesColor;
  this.selectedIndexPoints = safeOptions.selectedIndexPoints;
  this.tooltipFormatter = safeOptions.tooltipFormatter;
  this.yAxisLabelFormatter = safeOptions.yAxisLabelFormatter;
  this.yAxisTitle = safeOptions.yAxisTitle;
  Object.freeze(this);
};

exports.default = MwChartOneSeriesColumnOptions;